import { deviceDetector } from "utils";

export type IntroAuthPlatform = "ios" | "android" | "pc";

/** App shell → Apple/Google；其它（含 H5 / PC）→ pc Get Started */
export function resolveIntroAuthPlatform(): IntroAuthPlatform {
  if (deviceDetector.isIOSApp()) {
    return "ios";
  }
  if (deviceDetector.isAndroidApp()) {
    return "android";
  }
  return "pc";
}
